import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import React, { useState } from 'react'
import LoanHowWork from '../../../containers/PersonalLoan/HowWork'
import MotorHowWork from '../../../containers/MotorcycleFinancing/HowWork'
import { useTranslation } from 'react-i18next'

export const SMHomeSteps: React.FC = () => {

    const { t } = useTranslation()
    
    const [tabIndex, updateTabIndex] = useState(0)

    const changeTabIndex = (index: number) => {
        updateTabIndex(index)
    }

    // ======================= VIEWS
    return (
        <Box
            paddingBottom={{ xs: 2, lg: 5 }}
            sx={{
                backgroundColor: '#FFFDF7'
            }}
        >
            <Typography variant='h5' width={'100%'} textAlign={'center'} paddingTop={'60px'} paddingBottom={'40px'} fontWeight={700}>
                {t('t38')}
            </Typography>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                
                <Button key={0} onClick={() => changeTabIndex(0)}
                    variant='contained'
                    sx={{
                        borderRadius: '30px',
                        backgroundColor: 0 === tabIndex ? '#FFC107' : '#FFFDF7',
                        border: 0 === tabIndex ? 'none' : '1px solid #141F39',
                        width: '200px',
                        height: '60px',
                        color: '#141F39',
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: 0 === tabIndex ? 'rgba(251, 191, 35, 0.8)' : 'rgba(20, 31, 57, 0.1)',
                        },
                    }}
                >
                    {t('t39')}
                </Button>
                
                <Box width={20}></Box>
                <Button key={1} onClick={() => changeTabIndex(1)}
                    sx={{
                        borderRadius: '30px',
                        backgroundColor: 1 === tabIndex ? '#FFC107' : '#FFFDF7',
                        border: 1 === tabIndex ? 'none' : '1px solid #141F39',
                        width: '200px',
                        height: '60px',
                        color: '#141F39',
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: 1 === tabIndex ? 'rgba(251, 191, 35, 0.8)' : 'rgba(20, 31, 57, 0.1)',
                        },
                    }}
                >
                    {t('t40')}
                </Button>
            </Box>
            <div>
                {1 === tabIndex ? <LoanHowWork /> : <MotorHowWork />}
            </div> 
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeSteps
